import { Box } from "@mui/material";
import useAppSearch from "./hooks/useAppSearch";
import GlobalSearchInput from "./GlobalSearchSm/GlobalSearchInput";

export const AppSearch = () => {
  const {
    orgId,
    spaceId,
    workspaceMrn,
    isFocused,
    inputRef,
    query,
    scope,
    handle,
  } = useAppSearch();

  if (!orgId && !spaceId && !workspaceMrn) {
    return <></>;
  }

  return (
    <Box
      id="app-search"
      style={{
        position: "relative",
        marginRight: 16,
      }}
    >
      <GlobalSearchInput
        isFocused={isFocused}
        inputRef={inputRef}
        scope={scope}
        TextFieldProps={{
          query,
          handleFocus: handle.focus,
          handleChange: handle.change,
          handleKeyDown: handle.keyDown,
          handleToggleFocus: handle.toggleFocus,
          handleClickAway: handle.clickAway,
        }}
        EndAdornmentProps={{
          handleClear: handle.clear,
          handleScopeChange: handle.scopeChange,
          spaceId,
        }}
      />
    </Box>
  );
};
